import { Box, Typography } from "@mui/material";
import BasicBreadcrumbs from "../../components/breadcrumb";
import EmployeeList from "./employeeList";
import MissionInfo from "./missionInfo";

function ViewDetails({ id, misssionList }) {

  // console.log('dataList', misssionList);

  return (
    <Box
      sx={{
        width: "100%",
        px: { xs: 2 }, // padding for mobile and desktop
        py: { xs: 1 },        // vertical padding for mobile and desktop
      }}
    >
      {/* <BasicBreadcrumbs first="Mission Info" /> */}
      <MissionInfo data={misssionList} />
      <Box>
      </Box>
      <EmployeeList id={id} />
    </Box>
  );
}

export default ViewDetails;